import React from 'react';
import { Controller } from 'react-hook-form';

import { MultiSelectValueType } from '../../MultiSelect';

import {
  MultiSelectFieldControlProps,
  MultiSelectFieldProps
} from './GroupedMultiSelectField.types';

import {
  GroupedMultiSelectFieldControl,
  GroupedMultiSelectOptionalProps,
  GroupedMultiSelectValueType
} from './components/GroupedMultiSelectFieldControl';

interface GroupedMultiSelectFieldValueProps {
  value?: MultiSelectValueType;
}

function GroupedMultiSelectField<T>({
  autoFocus,
  classNamePrefix = null,
  closeMenuOnSelect = true,
  control,
  data = [],
  defaultValue = null,
  disabled = false,
  emptyValue = null,
  error,
  formatGroupLabel,
  formatOptionLabel,
  i18nLabel = null,
  i18nPlaceholder,
  inputWrapperClassName = null,
  isClearable = false,
  isLoading = false,
  isSearchable = false,
  labelClassName,
  menuIsOpen,
  menuPlacement = 'auto',
  menuPosition,
  multi = false,
  name,
  onBlur,
  onChange,
  onInputChange,
  onMenuClose,
  onMenuOpen,
  onMenuScrollToBottom,
  openMenuOnFocus,
  optionsLoading = false,
  placeholder = null,
  sortable,
  filterConfig,
  value: selectedValue
}: MultiSelectFieldControlProps<T> &
  MultiSelectFieldProps<T> &
  GroupedMultiSelectOptionalProps &
  GroupedMultiSelectFieldValueProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange: onMultiSelectChange, value, name },
        fieldState: { error: fieldError }
      }) => (
        <GroupedMultiSelectFieldControl
          autoFocus={autoFocus}
          classNamePrefix={classNamePrefix}
          closeMenuOnSelect={closeMenuOnSelect}
          data={data}
          defaultValue={defaultValue}
          disabled={disabled}
          emptyValue={emptyValue}
          error={fieldError?.message || error}
          formatGroupLabel={formatGroupLabel}
          formatOptionLabel={formatOptionLabel}
          i18nLabel={i18nLabel}
          i18nPlaceholder={i18nPlaceholder}
          inputWrapperClassName={inputWrapperClassName}
          isClearable={isClearable}
          isSearchable={isSearchable}
          labelClassName={labelClassName}
          menuIsOpen={menuIsOpen}
          menuPlacement={menuPlacement}
          menuPosition={menuPosition}
          multi={multi}
          onChange={(newValue) => {
            onMultiSelectChange(newValue);
            onChange?.(newValue);
          }}
          isLoading={isLoading}
          name={name}
          onBlur={onBlur}
          onInputChange={onInputChange}
          onMenuClose={onMenuClose}
          onMenuOpen={onMenuOpen}
          onMenuScrollToBottom={onMenuScrollToBottom}
          openMenuOnFocus={openMenuOnFocus}
          optionsLoading={optionsLoading}
          placeholder={placeholder}
          selectedValue={selectedValue}
          value={value as GroupedMultiSelectValueType}
          sortable={sortable}
          filterConfig={filterConfig}
        />
      )}
    />
  );
}

export default GroupedMultiSelectField;
